import React from 'react';
import { Link } from 'react-router-dom';
import '../styling/ProductsSubpages.css';
import ups1 from '../styling/images/ups/line_interactive/category1a.png';
import ups2 from '../styling/images/ups/line_interactive/category1b.png';
import ups3 from '../styling/images/ups/line_interactive/category1c.png';
import ups4 from '../styling/images/ups/online_1phase/category2a.png'
import ups5 from '../styling/images/ups/online_1phase/category2b.png'
import ups6 from '../styling/images/ups/online_3phase/category3a.png'
import ups7 from '../styling/images/ups/online_3phase/category3b.png'
import ups8 from '../styling/images/ups/online_3phase/category3c.png'

const Ups = () => {
  const categories = [
    {
      id: 1,
      name: 'LINE INTERACTIVE UPS',
      ups_images: [
        { id: 1, src: ups1, caption1: 'Pure Sine Wave UPS (Long Backup & Short Backup)', caption2: '1KVA to 5KVA' },
        { id: 2, src: ups2, caption1: 'Pure Sine Wave UPS (Long Backup)', caption2: '1KVA to 5KVA' },
        { id: 3, src: ups3, caption1: 'Simulated Sine Wave UPS', caption2: '650VA to 3000VA' }
      ]
    },{
      id: 2,
      name: 'ONLINE UPS - SINGLE PHASE',
      ups_images: [
        { id: 4, src: ups4, caption1: 'Rack Mount Online UPS', caption2: '1KVA to 10KVA' },
        { id: 5, src: ups5, caption1: 'Tower Body Online UPS', caption2: '1KVA to 10KVA' }
      ]
    },{
      id: 3,
      name: 'ONLINE UPS - THREE PHASE',
      ups_images: [ 
        { id: 6, src: ups6, caption1: '3 Phase In ~ 1 Phase Out', caption2: 'Online UPS'},
        { id: 7, src: ups7, caption1: '3 Phase In ~ 3 Phase Out (High Frequency)' , caption2: 'Online UPS'},
        { id: 8, src: ups8, caption1: '3 Phase In ~ 3 Phase Out (Low Frequency)', caption2: 'Online UPS'}
      ]
    }
  ];

  const scrollToHeading = (headingId) => {
    const element = document.getElementById(headingId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className='container'>
      <nav className="side-nav">
        <ul>
          {categories.map(category => (
            <li key={category.id}>
              <button onClick={() => scrollToHeading(`heading-${category.id}`)}>{category.name}</button>
              <ul>
                {category.ups_images.map(ups_image => (
                  <li key={ups_image.id}>
                    <Link to={`/product_items/Ups_cat/UpsSubpages/${ups_image.id}`}>
                      {ups_image.caption1}  {ups_image.caption2}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </nav>
      
      <div className="content">
        <h1>UPS</h1>
        <h3>UNINTERRUPTIBLE POWER SUPPLY</h3>
        {categories.map(category => (
          <div key={category.id} id={`heading-${category.id}`}>
            <h2>{category.name}</h2>
            <div className='row'>
              {category.ups_images.map(ups_image => (
                <div key={ups_image.id} className='category-products'>
                  <Link to={`/product_items/Ups_cat/UpsSubpages/${ups_image.id}`} state={{ productCategory: category.name, productCap1: ups_image.caption1, productCap2: ups_image.caption2}}>
                    <img src={ups_image.src} alt={` ${ups_image.id}`} className='category-images'/>
                  </Link>
                  <p>{ups_image.caption1}<br/>{ups_image.caption2}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      
      </div>

    </div>
  );
}

export default Ups;
